"use client";

import React from "react";
import { Link2, FileText, BarChart3, Users, Mail, Image as ImageIcon } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * BrokerProgram — Section 5: Tools & Marketing-Material
 * Drop-in für: src/pages/BrokerProgram/sections/ToolsMarketingMaterial.tsx
 *
 * 6 konkrete Tools, die Vermittler kostenlos bekommen.
 */

const tools = [{
  icon: Link2,
  title: "Persönlicher Tracking-Link",
  description: "Eindeutige URL, die jede Empfehlung Ihrem Account zuordnet. Funktioniert mit Cookies und über Wochen."
}, {
  icon: BarChart3,
  title: "Vermittler-Dashboard",
  description: "Live-Statistiken zu Klicks, Anmeldungen und Provision. Sehen Sie genau, was läuft — in Echtzeit."
}, {
  icon: ImageIcon,
  title: "Logos &amp; Banner-Pakete",
  description: "Brand-Assets in allen gängigen Grössen für Ihre Website, E-Mails oder Social-Media-Profile."
}, {
  icon: FileText,
  title: "PDF-Brochüren",
  description: "Druckfertige Onepager und Brochüren in Schweizer Hochdeutsch — für Kundengespräche und Mailings."
}, {
  icon: Mail,
  title: "E-Mail-Templates",
  description: "Fertige Empfehlungs-Mails in unterschiedlichen Tonalitäten (formell, locker, beratend) — anpassbar."
}, {
  icon: Users,
  title: "Persönlicher Ansprechpartner",
  description: "Direkter Kontakt zu Ihrem Vermittler-Manager bei PAGEMAKER24 — keine Hotline, keine Tickets."
}];
export default function ToolsMarketingMaterial() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Alles, was Sie zum Empfehlen brauchen
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Kostenlos, sofort verfügbar, alles auf Deutsch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map((t, i) => <div key={i} className="group bg-card border border-border rounded-xl p-7 hover:border-primary/40 hover:shadow-xl transition-all duration-300">
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <t.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight" dangerouslySetInnerHTML={{
            __html: t.title
          }} />
              <p className="text-base leading-relaxed text-muted-foreground" dangerouslySetInnerHTML={{
            __html: t.description
          }} />
            </div>)}
        </div>
      </div>
    </section>;
}